module.exports = __webpack_public_path__ + "static/media/ticket_campaign_preview_default_pic.06eafd5c.svg";